import apiClient from 'config/apiClient';

import { UserModel } from '../../user/libs/types';

import {
  AuthForgeRes,
  AuthForgotPasswordDto,
  AuthOAuthLoginDto,
  AuthOAuthLoginResult,
  AuthOAuthSignUpDto,
  LoginDto,
  LoginRes,
  SignUpDto,
  SignUpRes,
  UpdateMeDto,
} from './types';

export const login = (data: LoginDto) => apiClient.post<LoginRes>('/auth/login', data);
export const logout = (fcmToken?: string) => apiClient.post('/auth/logout', { fcmToken });
export const signUp = (data: SignUpDto) => apiClient.post<SignUpRes>('/auth/signup', data);

export const checkEmail = (email: string) => apiClient.post<string>('/auth/check-email', { email });

export const forgotPassword = (data: AuthForgotPasswordDto) =>
  apiClient.post<AuthForgeRes>('/auth/forgot-password', data);

export const resetPassword = (resetPasswordToken: string, password: string) =>
  apiClient.post<UserModel>(`/auth/reset-password/${resetPasswordToken}`, { password });

export const getMe = (token?: string) => {
  if (token) {
    return apiClient.get<UserModel>('/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  return apiClient.get<UserModel>('/auth/me');
};
export const updateMe = (data: UpdateMeDto) => apiClient.patch<UserModel>('/auth/me', data);

// SNS 로그인
export const loginWithKakao = (data: AuthOAuthLoginDto) =>
  apiClient.post<AuthOAuthLoginResult>('/auth/login/kakao', data);
export const loginWithNaver = (data: AuthOAuthLoginDto) =>
  apiClient.post<AuthOAuthLoginResult>('/auth/login/naver', data);
export const loginWithGoogle = (data: AuthOAuthLoginDto) =>
  apiClient.post<AuthOAuthLoginResult>('/auth/login/google', data);
export const loginWithApple = (data: AuthOAuthLoginDto) =>
  apiClient.post<AuthOAuthLoginResult>('/auth/login/apple', data);

/**
 * SNS 회원가입 추가 정보 입력
 */
export const oAuthSignUp = (data: AuthOAuthSignUpDto) => apiClient.post('/auth/oauth/signup', data);

/**
 * SNS 연결 해제
 */
export const disconnectOAuth = (userId: string) =>
  apiClient.patch(`/auth/disconnect/oauth/${userId}`);

/**
 * 회원 탈퇴
 */
export const deleteAccount = () => apiClient.delete('/auth/me/client');
